import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {
  async loadContract (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`contracts/${id}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadContracts () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('contracts/').then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}
